import type { StyleSystemProps } from '@withjoy/joykit';
import { FormControl as FormControlJoyKit } from '@withjoy/joykit';
import type { ComponentProps } from 'react';
import React from 'react';

const labelStyles: StyleSystemProps = {
  typographyVariant: 'label3',
};

export const FormControl = (props: ComponentProps<typeof FormControlJoyKit>) => (
  <FormControlJoyKit
    overrides={{
      Label: {
        props: labelStyles,
      },
      ...props.overrides,
    }}
    {...props}
  />
);
